export default __webpack_public_path__ + "static/media/Whittier District logo_600.5533ea83.jpg";